export const ENV_URL_MAP = {
  [process.env
    .NEXT_PUBLIC_PORTAL_URL as string]: `https://${process.env.NEXT_PUBLIC_INCYBER_PORTAL_URL}`,
  [process.env
    .NEXT_PUBLIC_PROD_URL as string]: `https://${process.env.NEXT_PUBLIC_INCYBER_PROD_URL}`,
  [process.env
    .NEXT_PUBLIC_INCYBER_PROD_URL as string]: `https://${process.env.NEXT_PUBLIC_PROD_URL}`,
  [process.env
    .NEXT_PUBLIC_INCYBER_PORTAL_URL as string]: `https://${process.env.NEXT_PUBLIC_PORTAL_URL}`
};
